import {titles} from '../../../utils/general/titles';
import {
    roles,
    rolesAll
} from '../../../utils/general/roles';
import {name} from '../../../utils/general/routers';
import {icons} from '../../../utils/general/icons';

export const menu = [

    {
        title: titles.organisations,
        roles: rolesAll,
        router: name.organisation,
        icon: icons.organisations,
        visibility: true,
        childrens: []
    },
    {
        title: titles.network,
        roles: rolesAll,
        router: name.network,
        icon: icons.network,
        visibility: true,
        childrens: [
            {
                title: titles.clientList,
                router: name.clientList,
                roles: rolesAll
            },
            {
                title: titles.commercialList,
                router: name.commercialList,
                roles: [roles.admin]
            }
        ]
    },
    {
        title: titles.settings,
        roles: [roles.admin],
        router: name.settings,
        icon: icons.settings,
        visibility: true,
        childrens: [
            {
                title: titles.domainList,
                router: name.domainList,
                roles: [roles.admin]
            },
            {
                title: titles.moduleList,
                router: name.moduleList,
                roles: [roles.admin]
            },
            {
                title: titles.functionnalityList,
                router: name.functionalityList,
                roles: [roles.admin]
            },
            {
                title: titles.typePacksList,
                router: name.typePackList,
                roles: [roles.admin]
            },
            {
                title: titles.packsList,
                router: name.packList,
                roles: [roles.admin]
            }
        ]
    },
    {
        title: titles.profile,
        roles: rolesAll,
        router: name.profile,
        icon: icons.settings,
        visibility: false,
        childrens: []
    },
    {
        title: titles.logs,
        roles: [roles.admin],
        router: name.logs,
        icon: icons.logs,
        visibility: true,
        childrens: []
    }
];
